// Main entry: the production View. Sim wrappers live under ./sim and are
// never imported here.
export { ACCOUNT_TYPE_BADGE_COLOR, AccountTypeBadge, accountTypeBadgeLabel } from "./AccountTypeBadge";
export type {
    AccountBadgeType,
    AccountType,
    AccountTypeBadgeProps,
    MultisigShape,
    SquadsAccountType
} from "./AccountTypeBadge";
